import { render } from "./ResumeCmt.vue?vue&type=template&id=065e8d5d&scoped=true"
import script from "./ResumeCmt.vue?vue&type=script&lang=js"
export * from "./ResumeCmt.vue?vue&type=script&lang=js"

import "./ResumeCmt.vue?vue&type=style&index=0&id=065e8d5d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-065e8d5d"]])

export default __exports__